<template>
  <div>
    <Table :columns="columns" :data="processedClaims" :is-row-clickable="true" @row-click="redirectToClaimDetailsPage">
      <template #friendlyId="{ row }">
        <div class="flex flex-col">
          <div class="flex items-center gap-1.5">
            <span>{{ row.friendlyId }}</span>
            <ExclamationCircleIcon v-if="hasRequiredAction(row)" class="w-4 h-4 text-yellow-500" />
          </div>
          <div class="mt-2">
            <span
              :class="[
                statusStyle(row.status),
                'inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium',
              ]"
            >
              {{ $t(`claim.status.${row.status}`) }}
            </span>
          </div>
        </div>
      </template>
      <template #customer="{ row }">
        <div v-if="row.customer" class="text-gray-800 space-y-1">
          <div class="font-semibold text-sm">{{ row.customer.firstName }} {{ row.customer.lastName }}</div>
          <div class="text-xs text-gray-600">
            {{ row.customer.email }}
          </div>
        </div>
      </template>
      <template #product="{ row }">
        <div v-if="row.claimProduct">{{ row.claimProduct.title }}</div>
        <div v-if="showStore && row.store" class="text-xs text-gray-500 mt-0.5">{{ row.store.salesChannel }}</div>
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { Pagination, Table } from "@estaly/ui";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import { mapGetters } from "vuex";

export default {
  components: {
    ExclamationCircleIcon,
    Table,
    Pagination,
  },

  props: ["claims", "currentPage", "totalPages", "totalCount"],

  computed: {
    ...mapGetters("claims", ["hasRequiredAction", "statusStyle"]),
    ...mapGetters("store", ["stores"]),

    showStore() {
      return this.stores?.length > 1;
    },

    columns() {
      return [
        { label: "Sinistre", field: "friendlyId", slot: "friendlyId" },
        { label: "Produit", field: "product", slot: "product" },
        { label: "Déclaration", field: "filedDate" },
        { label: "Client", field: "customerEmail", slot: "customer" },
      ];
    },
    processedClaims() {
      return this.claims.map((claim) => ({
        ...claim,
        rowClass: this.hasRequiredAction(claim) ? "bg-yellow-50" : "",
      }));
    },
  },

  methods: {
    handleChangePage: function (page) {
      this.$emit("changePage", page);
    },

    redirectToClaimDetailsPage: function (claim) {
      this.$emit("redirectToClaimDetailsPage", claim.friendlyId);
    },
  },
};
</script>
